import React from 'react'
import PropTypes from 'prop-types'

const ACTIVE_BG = 'bg-secondary-subtle'
const INACTIVE_BG = 'bg-light'

const ACTIVE_TEXT = 'text-secondary'
const INACTIVE_TEXT = ''

const ProgressBar = ({ max, current, finished }) => (
  <div
    className='d-flex gap-2 align-items-center mb-5'
    style={{color: 'var(--bs-secondary-bg-subtle)'}}
  >
    <i className='text-secondary bi-circle-fill' style={{fontSize: '1.25rem'}}></i>
    {max > 0 && [...Array(max).keys()].map(i => (
      <React.Fragment key={i}>
        <div
          className={`${i < current ? ACTIVE_BG : INACTIVE_BG} rounded flex-grow-1`}
          style={{height: '8px'}}
        />
        <i
          className={`${i < current ? ACTIVE_TEXT : INACTIVE_TEXT} bi-circle-fill`}
          style={{fontSize: '1.25rem'}}
        />
      </React.Fragment>
    ))}

    <div
      className={`${finished ? ACTIVE_BG : INACTIVE_BG} rounded flex-grow-1`}
      style={{height: '8px'}}
    />
    <i
      className={`${finished ? ACTIVE_TEXT : INACTIVE_TEXT} bi-gift-fill`}
      style={{fontSize: '2rem'}}
    />
  </div>
)

ProgressBar.propTypes = {
  max: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  finished: PropTypes.bool,
}

export default ProgressBar
